import { render, staticRenderFns } from "./VideoAdd.vue?vue&type=template&id=2e5d6b58&scoped=true"
import script from "./VideoAdd.vue?vue&type=script&lang=js"
export * from "./VideoAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5d6b58",
  null
  
)

export default component.exports